import React from 'react'
import Helmet from 'react-helmet'
import Link from 'gatsby-link'
import { PanelGroup, Panel, Tab, Row, Col, Button } from 'react-bootstrap'
import favIcon from '../images/favVerde.png'

import logoSmart from '../images/favAzul.png'
import logoWFinanceiro from '../images/favVerde.png'
import logoWEstoque from '../images/logoWEstoque.png'
import logoLuvnyl from '../images/logoLuvnyl.png'

import HeaderInterno from '../components/HeaderInterno'


class Produtos extends React.Component {

  render() {

		const siteTitle = "Descubra alguns produtos criados pela a CodeBox"
    const siteDescription = "Desenvolvemos soluções para aumentar a produtividade e reduzir custos, sempre em parceria com nossos clientes."

		
    return (
      <div style={{ margin: `0 auto`, position: 'relative', zIndex: 100}}>
        <Helmet>
          <title>{siteTitle}</title>
          <meta name="description" content={siteDescription} />
					<html lang="pt-br" />
					<link rel="shortcut icon" type="image/png" href={favIcon} />
          </Helmet>
        <HeaderInterno pagina="Produtos" menu="nivel1" />
        <div id="wrapperInterno">
				
        <h2 className="major">Produtos</h2>
        <h3 style={{backgroundColor:'#A6CE39', opacity: 0.8, textAlign: 'center'}}>&nbsp;Conheça nossos produtos e soluções.&nbsp;</h3>

				<Row style={{textAlign: 'center'}} >
				<Row>
					<Col xs={12} sm={12} md={6} lg={6} style={{paddingLeft: '40px', paddingRight: '40px', marginBottom: '50px' }}> 
						<Row style={{textAlign: 'center', alignContent: 'center', align: 'center'}} >
						<h3><img src={logoSmart} alt="SmartDocs Sistema para Gestão da Qualidade ISO" /><br/>SmartDocs</h3>
	<p>O SmartDocs é uma solução de gestão de documentos (GED) que organiza e automatiza os processos de armazenamento, publicação e disponibilização de documentos através da plataforma web (cloud) garantindo assim maior eficácia e produtividade na sua empresa.</p>
						{
						//<Link to="/produto/smartdocs"><Button bsStyle="primary" bsSize="small">Ver Mais</Button></Link>
						}
						</Row>
					</Col>
					<Col xs={12} sm={12} md={6} lg={6} style={{paddingLeft: '40px', paddingRight: '40px' }}>
						<Row style={{textAlign: 'center', alignContent: 'center', align: 'center'}} >
						<h3><img src={logoWFinanceiro} alt="wFinanceiro Sistema de controle de contas a pagar e receber"/><br/>wFinanceiro</h3>
	<p>Com o WebFinanceiro, você poderá controlar todas as contas a pagar e a receber da sua empresa e filiais via web! O sistema possui funcionalidades de controle contas, fluxo de caixa, relatórios por centro de custos, conciliação bancária e muito mais!</p>
					 {
					 //<Link to="/produto/wfinanceiro"><Button bsStyle="success" bsSize="small">Ver Mais</Button></Link>
					 }
						</Row>
					</Col>
				</Row>
				<br/><br/>
				</Row>
				<Row style={{backgroundColor: '#EAEDED', border: '1px solid #CCC', color: 'black', textAlign: 'center'}} >
				<br/><br/>
				<h1 style={{color: 'black'}}> Startups </h1>
				<Row>
					<Col xs={12} sm={12} md={6} lg={6} style={{paddingLeft: '40px', paddingRight: '40px', marginBottom: '50px' }}> 
						<Row style={{textAlign: 'center', alignContent: 'center', align: 'center'}} >
						<h3><img src={logoWEstoque} alt="wEstoque Sistema de Gestão Comercial" /></h3>
	<p>O wEstoque é um sistema que atua como ferramenta de controle de estoque e frente de loja on-line. Além do controle de estoque, o WebEstoque proporciona conectividade entre todas as filiais através da internet, centralizando as informações em tempo real de operação.
		<br/><br/>Fluxo de caixa, controle financeiro, gerenciamento de estoque e muitas outras funcionalidades essenciais para a administração de sua loja agora disponível na internet e seguramente protegida com senhas de acesso por níveis de privilégio.</p>
						<p>
						<Button bsStyle="warning" bsSize="small" href="https://www.westoque.com.br">Ir para o Site</Button>
						</p>
						</Row>
					</Col>
					<Col xs={12} sm={12} md={6} lg={6} style={{paddingLeft: '40px', paddingRight: '40px' }}>
						<Row style={{textAlign: 'center', alignContent: 'center', align: 'center'}} >
						<h3><img src={logoLuvnyl} alt="luvnyl.com - Encontro discos, lojas, pessoas e compartilhe sua paixão."/></h3>
	<p>A luvnyl é uma plataforma para amantes e vendedores de discos de vinil trocarem informações, gerenciarem suas coleções, vender e comprar títulos.<br/><br/>
	Na nossa plataforma é possível gerenciar a coleção de Lps e trocar informações com outros apaixonados por discos de vinil.</p>
						<Button bsStyle="danger" bsSize="small" href="https://www.luvnyl.com">Ir para o Site</Button>
						</Row>
					</Col>
				</Row>
				<br/><br/>
				</Row>
				<div id="bgProdutos" style={{zIndex: -10}}></div>
        </div>
      </div>
      
    )
  }
}

Produtos.propTypes = {
  route: React.PropTypes.object,
}

export default Produtos



// WEBPACK FOOTER //
// ./src/pages/produtos.js